/**
 * The slot registrations of `web/links` (1.J deliverable 20): the home pill, the Backlinks tab and
 * the Inspector tab (`header.pills.home`, `rail.tabs.backlinks`, `rail.tabs.inspector`).
 * `apps/web/src/editor-services/slots.ts` collects them as `SLOT_MODULES['web/links']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { BacklinksTab } from './backlinks/backlinks-tab.js';
import { HomePill } from './home/home-pill.js';
import { InspectorTab } from './inspector/inspector-tab.js';

export const owner: WorkPackageId = '1.J';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'header.pills', order: 40, owner: '1.J', component: HomePill },
  { slot: 'rail.tabs', order: 10, owner: '1.J', component: BacklinksTab },
  { slot: 'rail.tabs', order: 60, owner: '1.J', component: InspectorTab },
];
